import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DemoBanner from '../components/DemoBanner';
import AdProvider from '../components/AdProvider';
import AdBanner from '../components/AdBanner';
import FullpageAd from '../components/FullpageAd';

const LOGO = '/dailyreps3.png';

export default function UnifiedPlayerLayout() {
  const { logout, teamInfo } = useAuth();
  const basePath = '/player';
  const teamColor = teamInfo?.primary_color || '#f77c00';

  return (
    <AdProvider>
      <div className="app-layout">
        {teamInfo?.is_demo && <DemoBanner />}
        <header className="header">
          <div className="header-left">
            <img src={LOGO} alt="Train Daily" className="header-logo" />
            <div className="header-title">
              <span style={{ color: teamColor }}>{teamInfo?.name || 'Train Daily'}</span>
              {' '}Training
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <NavLink to={`${basePath}/faq`} style={{ color: 'var(--text-muted)', fontSize: '0.85rem', textDecoration: 'none' }}>FAQ</NavLink>
            <button className="header-logout" onClick={logout}>Log out</button>
          </div>
        </header>
        <AdBanner placement="top" />
        <Outlet />
        <AdBanner placement="bottom" />
        <div style={{ textAlign: 'center', fontSize: 14, color: '#fff', padding: '8px 0' }}>
          <a href="/support" style={{ color: '#fff', textDecoration: 'underline' }}>Support</a>
        </div>
        <nav className="bottom-nav">
          <NavLink to={basePath} end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">{'\u26BD'}</span>
            Today
          </NavLink>
          <NavLink to={`${basePath}/leaderboard`} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">{'\uD83C\uDFC6'}</span>
            Leaderboard
          </NavLink>
          <NavLink to={`${basePath}/me`} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">{'\uD83D\uDC64'}</span>
            Me
          </NavLink>
          <NavLink to={`${basePath}/merch`} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">{'\uD83D\uDED2'}</span>
            Merch
          </NavLink>
        </nav>
        <FullpageAd />
      </div>
    </AdProvider>
  );
}
